// @react/hooks/useBillingBillingPolicy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { billingBillingPolicyStore } from '@core/stores';

/**
 * React hook for BillingPolicy operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useBillingBillingPolicy } from '@react/hooks';
 *
 * const BillingPolicyList = observer(() => {
 *   const store = useBillingBillingPolicy();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useBillingBillingPolicy() {
  return billingBillingPolicyStore;
}
